import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { CornerRibbonLocation, CornerRibbonSize, CornerRibbonContext } from "../corner-ribbon-options";

@Component({
  selector: 'kz-corner-ribbon',
  host: {
    '[class]': '"kz-corner-ribbon" + (classes ? " " + classes : "")',
  },
  template: `<span><ng-content></ng-content></span>`,
  styleUrls: ['./kz-corner-ribbon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KzCornerRibbonComponent implements OnInit, OnChanges {
  private _classes: string;

  get classes(): string {
    return this._classes;
  }

  private _cornerRibbonLocation: CornerRibbonLocation = 'top-right';

  @Input()
  set cornerRibbonLocation(location: CornerRibbonLocation) {
    this._cornerRibbonLocation = location;
  }

  get cornerRibbonLocation(): CornerRibbonLocation {
    return this._cornerRibbonLocation;
  }

  private _cornerRibbonContext: CornerRibbonContext = 'default';

  @Input()
  set cornerRibbonContext(type: CornerRibbonContext) {
    this._cornerRibbonContext = type;
  }

  get cornerRibbonContext(): CornerRibbonContext {
    return this._cornerRibbonContext;
  }

  private _cornerRibbonSize: CornerRibbonSize = 'default';

  @Input()
  set cornerRibbonSize(size: CornerRibbonSize) {
    this._cornerRibbonSize = size;
  }

  get cornerRibbonSize(): CornerRibbonSize {
    return this._cornerRibbonSize;
  }

  constructor(
      private _changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this._updateClasses();
    this._changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._updateClasses();
    this._changeDetectorRef.detectChanges();
  }

  private _updateClasses() {
    this._classes = ` kz-corner-ribbon--${ this.cornerRibbonLocation }`;

    if (this.cornerRibbonContext && this.cornerRibbonContext != 'default') {
      this._classes += ` kz-corner-ribbon--${ this.cornerRibbonContext }`;
    }

    if (this.cornerRibbonSize && this.cornerRibbonSize != 'default') {
      this._classes += ` kz-corner-ribbon--${ this.cornerRibbonSize }`;
    }
  }

}
